import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import ToastService from "../../../../services/toastService/ToastService";
import FormCreator from "../../../../components/Forms/FormCreator";
import { CertificationRenewalData } from "../data/CertificationRenewal.data";
import "./CertificationRenewalModal.scss";

const formatDate = (date) => {
  if (!date) return "-";
  const m = moment(date);
  return m.isValid() ? m.format("DD MMM YYYY") : "-";
};

const CertificationRenewalModal = ({
  show,
  onClose,
  certificate,
  companyName,
}) => {
  const formRef = useRef();
  const [formData, setFormData] = useState(CertificationRenewalData);

  const handleSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    ToastService.success("Certification renewal updated successfully!");
    onClose();
  };

  const formattedStartDate = certificate?.issuanceStartDate
    ? formatDate(certificate.issuanceStartDate)
    : "-";

  const formattedEndDate = certificate?.issuanceEndDate
    ? formatDate(certificate.issuanceEndDate)
    : "-";

  const certNumber = certificate?.certificateNumber || "-";
  const category = certificate?.category || "-";
  const displayCompany = companyName || "-";
  const rating = certificate?.tickRating || "-";

  const isExpired = certificate?.issuanceEndDate
    ? moment(certificate.issuanceEndDate).isBefore(moment())
    : false;

  const expiryText = certificate?.issuanceEndDate
    ? isExpired
      ? "Expired"
      : `Expires ${moment(certificate.issuanceEndDate).fromNow()}`
    : "Active";

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="xl"
      className="certification-renewal-modal"
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton className="renewal-modal-header">
        <div className="header-left">
          <h4 className="modal-title-text">
            Certification Renewal ID:{" "}
            <span className="cert-id-highlight">{certNumber}</span>
          </h4>
        </div>
        <div className="header-right">
          <span className={`expiry-badge ${isExpired ? "badge-expired" : ""}`}>
            {expiryText}
          </span>
          <span className="expiry-date-label">
            Expiry date: <strong>{formattedEndDate}</strong>
          </span>
        </div>
      </Modal.Header>

      <Modal.Body className="renewal-modal-body">
        {/* Status Indicator Row */}
        <div className="renewal-status-bar">
          <span className="status-label">Status:</span>
          <span className={`status-pill ${isExpired ? "status-expired" : "status-active"}`}>
            {isExpired ? "Expired" : "Active"}
          </span>
        </div>


        {/* 2-Column Responsive Layout */}
        <div className="renewal-content-grid">
          {/* Left Panel: Certification Details */}
          <div className="detail-panel-card certification-details-card">
            <div className="panel-header">
              <h5 className="panel-title">Certification Details</h5>
              <button
                type="button"
                className="btn-more-details"
                onClick={() => {}}
              >
                More details
              </button>
            </div>
            <div className="panel-body">
              <div className="info-grid">
                <div className="info-item">
                  <span className="info-label">Cert. number</span>
                  <span className="info-value font-bold">{certNumber}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Category</span>
                  <span className="info-value">{category}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Company</span>
                  <span className="info-value">{displayCompany}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Rating</span>
                  <span className="info-value">{rating}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Issued on</span>
                  <span className="info-value">{formattedStartDate}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Status</span>
                  <span className="info-value text-success font-bold">Active</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Expires on</span>
                  <span className="info-value">{formattedEndDate}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Case officer</span>
                  <span className="info-value text-muted">-</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Panel: Renewal Details using FormCreator */}
          <div className="detail-panel-card renewal-details-card">
            <div className="panel-header">
              <h5 className="panel-title">Renewal Details</h5>
            </div>
            <div className="panel-body form-creator-panel-body">
              <FormCreator
                ref={formRef}
                {...formData}
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="renewal-modal-footer">
        <button
          type="button"
          className="btn-cancel"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn-submit"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CertificationRenewalModal;
